(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class NuraLoadMore extends HTMLElement {
    constructor() {
      super();
      this.grid = this.querySelector('#product-grid');
      this.button = this.querySelector('[data-load-more-button]');
      this.countEl = this.querySelector('[data-load-more-count]');
      this.barEl = this.querySelector('[data-load-more-bar]');
      if (this.button) {
        this.button.addEventListener('click', this.loadMore.bind(this));
      }
    }

    async loadMore() {
      const nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl) return;
      this.button.setAttribute('aria-busy', 'true');
      this.button.disabled = true;
      try {
        const response = await fetch(nextUrl);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newGrid = doc.querySelector('#product-grid');
        const newRoot = doc.querySelector('nura-load-more');
        if (newGrid && this.grid) {
          Array.from(newGrid.children).forEach((child) => this.grid.appendChild(child));
        }
        if (newRoot) {
          const newNextUrl = newRoot.getAttribute('data-next-url');
          if (newNextUrl) {
            this.setAttribute('data-next-url', newNextUrl);
          } else {
            this.removeAttribute('data-next-url');
            this.button.remove();
          }
          const newCount = newRoot.querySelector('[data-load-more-count]');
          const newBar = newRoot.querySelector('[data-load-more-bar]');
          if (newCount && this.countEl) this.countEl.textContent = newCount.textContent;
          if (newBar && this.barEl) this.barEl.style.width = newBar.style.width;
        }
      } catch (error) {
        window.location.href = nextUrl;
      } finally {
        if (this.button) {
          this.button.setAttribute('aria-busy', 'false');
          this.button.disabled = false;
        }
      }
    }
  }

  customElements.define('nura-load-more', NuraLoadMore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-featured-products"] && !Shopify.designMode) return;
  try {
    
  class NuraProductTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[data-nura-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-nura-panel]'));
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
    }

    onTabClick(event) {
      const index = event.currentTarget.getAttribute('data-nura-tab');
      this.tabs.forEach((tab) => {
        const active = tab.getAttribute('data-nura-tab') === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        tab.classList.toggle('is-active', active);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-nura-panel') !== index;
      });
    }
  }

  customElements.define('nura-product-tabs', NuraProductTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-routines"] && !Shopify.designMode) return;
  try {
    
  class NuraRoutineTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = Array.from(this.querySelectorAll('[data-nura-routine-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-nura-routine-panel]'));
      this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
    }

    onTabClick(event) {
      const index = event.currentTarget.getAttribute('data-nura-routine-tab');
      this.tabs.forEach((tab) => {
        const active = tab.getAttribute('data-nura-routine-tab') === index;
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        tab.classList.toggle('is-active', active);
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.getAttribute('data-nura-routine-panel') !== index;
      });
    }
  }

  customElements.define('nura-routine-tabs', NuraRoutineTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nura-sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class NuraStickyAtc extends HTMLElement {
    constructor() {
      super();
      this.targetId = this.getAttribute('data-target-id');
      this.button = this.querySelector('.nura-sticky-atc__button');
      this.target = this.targetId ? document.getElementById(this.targetId) : null;
      if (!this.target) {
        // Fall back to the real add-to-cart button's stable id prefix -
        // the exact id includes the main product section's runtime
        // section.id, which the target_button_id setting can't predict.
        this.target = document.querySelector('[id^="ProductSubmitButton-"]');
      }
      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
      if (this.target && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.onIntersect.bind(this), { threshold: 0 });
        this.observer.observe(this.target);
      }
      if (this.target && this.button && 'MutationObserver' in window) {
        // Stay in sync if the real button's availability changes after
        // load (e.g. the shopper picks a different, out-of-stock variant).
        this.syncObserver = new MutationObserver(this.syncAvailability.bind(this));
        this.syncObserver.observe(this.target, { attributes: true, attributeFilter: ['disabled'] });
        this.syncAvailability();
      }
    }

    onIntersect(entries) {
      const entry = entries[0];
      this.hidden = entry.isIntersecting;
    }

    syncAvailability() {
      const unavailable = this.target.disabled;
      this.button.disabled = unavailable;
      this.button.textContent = unavailable ? this.dataset.soldOutLabel : this.dataset.addLabel;
    }

    onClick() {
      if (this.target && !this.target.disabled) this.target.click();
    }
  }

  customElements.define('nura-sticky-atc', NuraStickyAtc);

  } catch(e) { console.error(e); }
})();
})();
